<template>
<div class="main tac norecord">
    <i v-if="showCry" class="iconfont" style="margin-left:35px;color:#ccc;">&#xe609;</i>
    <i v-if="showSmile" class="iconfont green" style="margin-left:35px;">&#xe77f;</i>
    <p class="mtw c6">{{msg}}</p>
</div>
</template>
<script>
import Vue from "vue";
import { Toast } from "vant";
import wx from "weixin-js-sdk";
import weChat from "@/assets/scripts/wechat";
Vue.use(Toast);

export default {
  name: "ScanCodeWriteOff",
  data() {
    return {
      msg:'',
      showCry:false,
      showSmile:false
    };
  },
  created() {
    let url = ''
    //console.log(this.$route.query.type)  //问号传参
    if(this.$route.query.type == 'order'){
        //核销订单
        url = "club_write_off/verifyOrder"
    }else if(this.$route.query.type == 'coupon'){
        //核销优惠券
        url = "club_write_off/verifyCoupon"
    }else{
        // Toast.fail({
        //     message:'缺少参数！',
        //     duration:2000
        // })
        // setTimeout(function(){
        //     // location.href=`${location.origin}` + "/venue/#/scancode"
        // }, 2000)
        this.showCry = true
        this.msg = '缺少参数！'
        return
    } 
    
    let _this = this
    //核销优惠券
    this.$http.post(url,{
        relateId: this.$route.query.relateId,
        targetType: this.$route.query.targetType,
    }).then(res => {
        if (!res.data.code) {
            Toast.success({
                message:'核销成功',
                duration:1500
            })
            // this.showSmile = true
            // this.msg = '核销成功！'
            setTimeout(function(){
              // location.href=`${location.origin}` + "/venue/#/scancode" //点返回回到scancodewriteoff 会重复核销
              _this.$router.replace("/scancode")  //替换当前url，点返回不会回到scancodewriteoff
            }, 1500) 
        } else {
            // Toast.fail({
            //     message:res.data.message,
            //     duration:2000
            // })
            // setTimeout(function(){
            //     // location.href=`${location.origin}` + "/venue/#/scancode"
            // }, 2000)
            this.showCry = true
            this.msg = res.data.message
        }
    })
  },
  methods: {
    
  }
};


// $(function () {
//   //防止页面后退 影响全局
//   history.pushState(null, null, document.URL);
//   window.addEventListener('popstate', function () {
//     history.pushState(null, null, document.URL);
//   });
// })
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/ScanCodeWriteOff.vue